import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { orderBy } from 'natural-orderby';

import { config } from '../../../../../../config/index';
import Searchbar from '../../../../../../components/Searchbar/index.js';

import { GET, newFetch } from '../../../../../../helpers/fetch.js';

import SpringLoader from '../../../../../../components/SpringLoader/SpringLoader.js';
import ToastUtil from '../../../../../../components/ToastNotification/ToastUtil/index.js';
import AlertService from '../../../../../../components/SweetAlert/index.js';
import placeholderImage from '../../../../../../assets/images/placeholder.jpg';
const { API_URL } = config;

const ClientUsers = ({ clientId, setActiveUserTabPage, setSelectedUser }) => {
  const token = localStorage.getItem('token');
  const [clientUsers, setClientUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIds = [...selectedIds];

      updatedSelectedIds.push(parseInt(e.target.value));
      setSelectedIds(updatedSelectedIds);
    } else {
      let updatedSelectedIds = [...selectedIds].filter(
        (id) => id !== parseInt(e.target.value)
      );

      setSelectedIds(updatedSelectedIds);
    }
  };

  const checkboxAllOn = (e) => {
    if (e.target.checked) {
      let ids = filteredUsers.map((user) => user.id);
      setSelectedIds(ids);
    } else {
      setSelectedIds([]);
    }
  };

  const searchHandler = (e) => {
    let filtered = [...clientUsers].filter((user) => {
      let name = `${user.name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });
    setFilteredUsers(filtered);
  };

  const deleteUser = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this User?'
      )
    ) {
      const url = `${API_URL}/client/users/${id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();
        if (response.ok) {
          ToastUtil.success('User successfully deleted!');
          window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteSelectedHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete these Users?'
      )
    ) {
      var failed = [];
      for (let id of selectedIds) {
        const url = `${API_URL}/client/users/${id}`;

        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();
        if (!response.ok) {
          // throw new Error(response.statusText)
          failed.push(id);
        }
      }

      if (failed.length > 0) {
        return ToastUtil.error('Failed to delete users that have data!');
      }

      ToastUtil.success('Users successfully deleted!');
      window.location.reload();
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      let response = await newFetch(GET, `/client/users/client/${clientId}`);
      if (response.success) {
        setClientUsers(response.data);
        setFilteredUsers(JSON.parse(JSON.stringify(response.data)));
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-2 pt-1 d-flex align-items-center">
        <h6 className="flex-grow-1" style={{fontWeight: 'bolder'}}>
          User Management
        </h6>
          <button
            className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
            style={{ width: '200px' }}
            onClick={() => {
              setActiveUserTabPage('add');
            }}
          >
            Add New
          </button>
      </div>
      <div className="d-flex flex-row align-items-center py-3">
        <h6 className="flex-grow-1">User ({filteredUsers.length})</h6>
        <Searchbar
          search={(e) => searchHandler(e)}
          placeholder="Search user"
        />
      </div>
      <div className="">
        <table className="table table-borderless mb-0">
          <thead className="border-bottom">
            <tr>
              <th className="py-3 text-muted fw-normal">
                <div className="form-check">
                  <input
                    className="form-check-input position-static"
                    onChange={checkboxAllOn}
                    type="checkbox"
                  />
                </div>
              </th>
              {selectedIds.length > 0 ? (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Name</th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-danger fw-normal">
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={deleteSelectedHandler}
                    >
                      Delete
                    </div>
                  </th>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Name</th>
                  <th className="py-3 text-muted fw-normal">Position</th>
                  <th className="py-3 text-muted fw-normal">Email</th>
                  <th className="py-3 text-muted fw-normal"></th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => {
                return (
                  <tr key={user.id} className="border-bottom">
                    <td>
                      <div className="form-check">
                        <input
                          className="form-check-input position-static"
                          type="checkbox"
                          checked={selectedIds.some((id) => id === user.id)}
                          value={user.id}
                          onChange={checkboxHandler}
                        />
                      </div>
                    </td>
                    <td>
                      <div style={{width: 250}}>
                      <Link
                        className="d-flex align-items-center"
                        style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
                        to={`/clients/client/${clientId}`}
                        onClick={(e) => {
                          e.preventDefault(); 
                          setActiveUserTabPage('edit');
                          setSelectedUser(user.id);
                        }}
                      >
                        <div
                          className="rounded-circle border me-3"
                          style={{
                            position: 'relative',
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            src={user.photo ? user.photo : placeholderImage}
                            alt="user"
                            style={{
                              width: '30px',
                              height: '30px'
                            }}
                          />
                        </div>
                        <strong
                          className={
                            !user.active ? 'text-danger' : 'text-muted'
                          }
                        >
                          {user.first_name}
                        </strong>
                      </Link>
                      </div>
                    </td>
                    <td className="text-muted">{user.designation}</td>
                    <td className="text-muted">{user.email}</td>
                    {/* <td className="text-muted">
                      {user?.designation ? (
                        <span className="badge rounded-pill bg-primary me-2 p-2">
                          {user.designation}
                        </span>
                      ) : (
                        <span>--</span>
                      )}
                    </td> */}
                    <td className="text-center">
                      <div
                        style={{ cursor: 'pointer' }}
                        className="dropdown custom-dropdown"
                      >
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i
                            className="fas fa-ellipsis-h adjust-fs"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          ></i>
                        </button>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          style={{ width: '150px' }}
                        >
                          <Link
                            to={`/clients/client/${clientId}`}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item border-bottom pb-2 adjust-fs"
                            onClick={(e) => {
                              e.preventDefault(); 
                              setActiveUserTabPage('edit');
                              setSelectedUser(user.id);
                            }}
                          >
                            Edit
                          </Link>
                          <div
                            onClick={() => deleteUser(user.id)}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item pt-2 adjust-fs"
                          >
                            Delete
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {loading ? (
                    <div className="springloader-holder">
                      <SpringLoader></SpringLoader>
                    </div>
                  ) : (
                    <div className="text-center text-muted my-3 pb-4">
                      <i>No results</i>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientUsers;
